<template>
    <Paper :header="$t('companyDetail.videos.header')" class="videos-root">
        <Carousel
            :component="getComponent()"
            :items="items"
            @item-click="openVideoDialog"
            onlyShowSingleItem
            hideArrows
        />
    </Paper>
</template>

<script>
import VideosCarouselItem from '~/components/miscellaneous/Videos.CarouselItem';
import DialogService from '~/services/DialogService';

export default {
    name: 'Videos',

    props: {
        items: Array,
    },
    methods: {
        getComponent() {
            return VideosCarouselItem;
        },
        openVideoDialog(item) {
            DialogService.openVideoDialog(item);
        },
    },
};
</script>

<style scoped>
.videos-root {
    overflow: hidden;
    max-height: 100%;
    max-width: 100%;
}
</style>
